import {Component, Inject, OnInit, ViewChild} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material';
import {MatSort} from '@angular/material/sort';
import {MatPaginator} from '@angular/material/paginator';
import {MatTableDataSource} from '@angular/material/table';
import {CommonService} from '../../../services/common.service';

@Component({
  templateUrl: './command-accessories-dialog.component.html'
})
export class CommandAccessoriesDialogComponent implements OnInit {

  @ViewChild(MatSort, {static: false}) set matSort(ms: MatSort) {
    this.sort = ms;
    this.setDataSourceAttributes();
  }
  @ViewChild(MatPaginator, {static: false}) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }

  private paginator: MatPaginator;
  private sort: MatSort;
  public accessories: any;
  public commandDetailID: number;
  public dataSource: MatTableDataSource<any>;
  public displayedColumns: string[];
  public loading: boolean;

  constructor(private matDialog: MatDialog,
              private matDialogRef: MatDialogRef<CommandAccessoriesDialogComponent>,
              private commonService: CommonService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.commandDetailID = this.data.commandDetailID;
    this.dataSource = new MatTableDataSource<any>([]);
    this.displayedColumns = ['id', 'accessory_category_description', 'value_to_load', 'value_loaded'];
    this.accessories = [];
    this.loading = true;
  }

  public async ngOnInit() {
    this.accessories = await this.commonService.getSimpleList(`loading_command/web/details/${this.commandDetailID}/accessories`);
    this.dataSource = new MatTableDataSource<any>(this.accessories);
    this.loading = false;
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }

  public closeDialog(): void {
    this.matDialogRef.close();
  }

  setDataSourceAttributes() {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }
}
